/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PaginationToolbar = _interopRequireDefault(require("../packages/PaginationToolbar"));
var _shouldComponentUpdate2 = _interopRequireDefault(require("../packages/shouldComponentUpdate"));
var _ColumnLayout = _interopRequireDefault(require("./ColumnLayout"));
var _FakeFlex = _interopRequireDefault(require("../FakeFlex"));
var _join = _interopRequireDefault(require("../packages/join"));
var _context = require("../context");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};
var InovuaDataGridLayout = function (_Component) {
  (0, _inherits2.default)(InovuaDataGridLayout, _Component);
  var _super = _createSuper(InovuaDataGridLayout);
  function InovuaDataGridLayout(props) {
    var _this;
    (0, _classCallCheck2.default)(this, InovuaDataGridLayout);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domNode", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refColumnLayout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "columnLayout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragHeader", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDOMNode", function () {
      return _this.domNode;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderPageList", function (list) {
      if (!_reactDom.createPortal) {
        return list;
      }
      return _this.props.renderInPortal(list);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowMouseEnter", function (event, rowProps) {
      _this.props.onRowMouseEnter && _this.props.onRowMouseEnter(event, rowProps);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowMouseLeave", function (event, rowProps) {
      _this.props.onRowMouseLeave && _this.props.onRowMouseLeave(event, rowProps);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVirtualList", function () {
      return _this.columnLayout && _this.columnLayout.getVirtualList();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRenderRange", function () {
      return _this.columnLayout.getRenderRange();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRowFullyVisible", function (index) {
      return _this.columnLayout.isRowFullyVisible(index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollLeft", function () {
      return _this.columnLayout ? _this.columnLayout.scrollLeft || 0 : 0;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getColumnLayout", function () {
      return _this.columnLayout;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setScrollLeft", function (scrollLeft) {
      if (_this.columnLayout) {
        _this.columnLayout.setScrollLeft(scrollLeft);
        if (_this.dragHeader) {
          _this.dragHeader.setScrollLeft(scrollLeft);
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollTop", function () {
      return _this.columnLayout ? _this.columnLayout.scrollTop || 0 : 0;
    });
    _this.ref = function (domNode) {
      _this.domNode = domNode;
    };
    _this.refColumnLayout = function (layout) {
      _this.columnLayout = layout;
    };
    return _this;
  }
  (0, _createClass2.default)(InovuaDataGridLayout, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var Footer = this.props.Footer;
      return _react.default.createElement(_context.Consumer, null, function (computedProps) {
        var ColumnLayoutCmp = computedProps && computedProps.ColumnLayout || _ColumnLayout.default;
        return _react.default.createElement("div", {
          className: 'InovuaReactDataGrid__body',
          ref: _this2.ref
        }, _react.default.createElement(_FakeFlex.default, {
          flexIndex: 0,
          getNode: _this2.getDOMNode,
          useNativeFlex: computedProps.useNativeFlex
        }, _react.default.createElement(ColumnLayoutCmp, {
          key: "collayout",
          ref: _this2.refColumnLayout,
          rtl: computedProps.rtl,
          coverHandleRef: computedProps.coverHandleRef
        }), _this2.renderPaginationToolbar(computedProps), computedProps.computedFooterRows && Footer ? _react.default.createElement(Footer, {
          key: "footer",
          rows: computedProps.computedFooterRows
        }) : null));
      });
    }
  }, {
    key: "renderPaginationToolbar",
    value: function renderPaginationToolbar(computedProps) {
      var pagination = computedProps.pagination,
        paginationProps = computedProps.paginationProps,
        i18n = computedProps.i18n,
        theme = computedProps.theme,
        pageSizes = computedProps.pageSizes;
      if (!pagination) {
        return null;
      }
      if (!paginationProps || paginationProps.livePagination) {
        return null;
      }
      var result;
      if (computedProps.renderPaginationToolbar) {
        result = computedProps.renderPaginationToolbar(paginationProps);
      }
      var paginationToolbarProps = _objectSpread(_objectSpread({
        perPageText: i18n('perPageText'),
        pageText: i18n('pageText'),
        ofText: i18n('ofText'),
        showingText: i18n('showingText'),
        rtl: computedProps.rtl
      }, paginationProps), {}, {
        pageSizes: pageSizes,
        onClick: stopPropagation,
        theme: theme,
        className: (0, _join.default)(paginationProps.className, this.props.useNativeFlex ? 'InovuaReactDataGrid-modifier--relative' : '')
      });
      paginationToolbarProps.bordered = false;
      delete paginationToolbarProps.livePagination;
      if (result === undefined) {
        result = _react.default.createElement(_PaginationToolbar.default, _objectSpread(_objectSpread({
          key: "paginationtoolbar"
        }, paginationToolbarProps), {}, {
          constrainTo: this.props.constrainTo,
          renderPageList: this.renderPageList
        }));
      }
      return result;
    }
  }]);
  return InovuaDataGridLayout;
}(_react.Component);
(0, _defineProperty2.default)(InovuaDataGridLayout, "defaultProps", void 0);
(0, _defineProperty2.default)(InovuaDataGridLayout, "propTypes", void 0);
InovuaDataGridLayout.defaultProps = {
  defaultScrollTop: 0,
  onRowMouseEnter: function onRowMouseEnter() {},
  onRowMouseLeave: function onRowMouseLeave() {},
  rowPlaceholderDelay: 300
};
InovuaDataGridLayout.propTypes = {
  i18n: _propTypes.default.func,
  shouldComponentUpdate: _propTypes.default.func,
  constrainTo: _propTypes.default.any,
  Footer: _propTypes.default.any,
  loading: _propTypes.default.bool,
  onScroll: _propTypes.default.func,
  onRowMouseEnter: _propTypes.default.func,
  onRowMouseLeave: _propTypes.default.func
};
var _default = InovuaDataGridLayout;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/index.js
// module id = 573
// module chunks = 0